import LeftMenu from './LeftMenu.vue'

export default LeftMenu
